import { render, staticRenderFns } from "./TicketDeadline.vue?vue&type=template&id=360a53ca"
import script from "./TicketDeadline.vue?vue&type=script&lang=js"
export * from "./TicketDeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports